import { isDemoContentAllowed } from "../../Common/api/v4/previewGuard";
import { DEMO_CONTENT_ITEMS, DEMO_GALLERY_POSTS, createDemoGallerySections } from "../../Common/api/v4/demoContent";

// Keep preview content in the view layer: it must never replace an API result
// or masquerade as a customer's reservations, photos, or action items.
export function resolveHomeAvailability(query) {
  const accessDenied = ["authentication", "authorization"].includes(query.error?.kind);
  const liveHome = accessDenied ? null : query.data?.data || null;
  const preview = !liveHome && !accessDenied && isDemoContentAllowed();
  const home = liveHome || (preview ? {
    upcomingSchedules: [],
    completedSchedules: [],
    products: [],
    reviewPhotos: [],
    galleryPosts: DEMO_GALLERY_POSTS,
    gallerySections: createDemoGallerySections() || [],
    events: DEMO_CONTENT_ITEMS.filter((item) => ["event", "promotion"].includes(item.type)),
    notices: DEMO_CONTENT_ITEMS.filter((item) => item.type === "notice"),
    faqs: DEMO_CONTENT_ITEMS.filter((item) => item.type === "faq"),
    popularThemes: [],
  } : null);
  return {
    home,
    preview,
    accessDenied,
    liveHome,
    unavailable: !liveHome,
    loading: Boolean(query.configured && query.isLoading),
    showNotice: !liveHome || Boolean(query.error),
  };
}
